import React, { useEffect, useRef } from 'react';
import { Box, Container, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import gsap from 'gsap';
import Marquee from 'react-fast-marquee';
import SmoothWaveText from '../../Components/SmoothWaveText';
import Portfolio2 from './Portfolio2';
import { PortfolioDetailsNormalized } from '../Portfolio/PortfolioDetails/PortfolioData';

const PortfolioSection: React.FC = () => {
  const navigate = useNavigate();
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (sectionRef.current) {
      gsap.fromTo(
        sectionRef.current,
        { opacity: 0, y: 40 },
        { opacity: 1, y: 0, duration: 1, ease: 'power3.out' },
      );
    }
  }, []);

  return (
    <Box
      id="portfolio"
      ref={sectionRef}
      sx={{ py: { xs: 6, md: 8}, bgcolor: '#0f63a5' }}
    >
      <Box>
        <Box sx={{ py: 4, overflow: 'hidden' }}>
          <Container maxWidth="lg" sx={{ borderTop: '1px solid #777777' }}>
            {/* Header */}
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                my: 4,
                pt: 2,
              }}
            >
              <SmoothWaveText
                variant="subtitle2"
                sx={{
                  color: '#fff',
                  fontFamily: 'GilroyBold, sans-serif',
                  textTransform: 'uppercase',
                  fontSize: '14px',
                }}
              >
                // let me show you
              </SmoothWaveText>

              <SmoothWaveText
                variant="subtitle2"
                className="cursor-hover-target"
                onClick={() => navigate('/portfolio')}
                sx={{
                  color: '#fff',
                  fontFamily: 'GilroyBold, sans-serif',
                  textTransform: 'uppercase',
                  fontSize: '14px',
                  textDecoration: 'underline',
                  cursor: 'pointer',
                  '&:hover': { color: '#000' },
                }}
              >
                (( project all ))
              </SmoothWaveText>
            </Box>
          </Container>

          {/* Marquee */}
          {/* <Marquee gradient={false} speed={80} style={{ overflow: 'hidden' }}>
            {Array.from({ length: 10 }, (_, index) => (
              <Typography
                className="cursor-hover-target"
                key={index}
                variant="h2"
                component="span"
                sx={{
                  fontSize: { xs: '40px', md: '40px' },
                  fontFamily: 'GilroyBold, sans-serif',
                  color: index % 2 === 0 ? '#fff' : 'transparent',
                  WebkitTextStroke: index % 2 === 0 ? '0px' : '1px #fff',
                  textTransform: 'uppercase',
                  mx: 3,
                  whiteSpace: 'nowrap',
                }}
              >
                Exhibits
              </Typography>
            ))}
          </Marquee> */}
        </Box>
      </Box>

      <Container maxWidth="xl">
        {/* If Portfolio2 accepts items, pass the normalized list to preserve alt text downstream */}
        {/* <Portfolio2 items={PortfolioDetailsNormalized} /> */}
        <Portfolio2 />
      </Container>
    </Box>
  );
};

export default PortfolioSection;
